export default "__VITE_ASSET__FS7sfDTY__"